import { Merchant } from "../services/models"

export const isMerchantServicesType = (merchant: Merchant): boolean => {
  return merchant.type === 'services';
}

export const isParentMerchant = (merchant: Merchant): boolean =>
  Boolean(merchant.multiStore && !merchant.parentMerchant);